<!-- Heading -->
<div #scrollable class="scroll-sidebar scroll-sidebar-auth opacity-block-double">
  <div class="container-fluid pb-6 my-7 my-lg-12">
    <div class="row-col-blocks row align-items-center justify-content-between">
      <div class="col-12 col-lg">
        <div class="text-center">
          <i-feather class="logo-big effect3d" name="skype" width="133" height="133"></i-feather>
        </div>
        <h1 class="font-bold text-center">Skype</h1>
        <!-- Text -->
        <p class="text-center mb-6">Пожалуйста, авторизуйтесь.</p>
        <alert [type]="'danger'" class="d-block"> Функционал в очереди на разработку </alert>
      </div>
      <div class="col-12 col-lg">
        <!-- Form -->
        <form [formGroup]="Form" (submit)="onSubmit()" class="mb-6 w-100">
          <!-- Email -->
          <div class="form-group">
            <label for="login" class="sr-only">Логин или E-mail</label>
            <input formControlName="login" type="text" class="form-control form-control-lg" id="login" placeholder="" />
          </div>
          <!-- Password -->
          <div class="form-group">
            <label for="password" class="sr-only">Пароль</label>
            <input
              formControlName="password"
              type="password"
              class="form-control form-control-lg"
              id="password"
              placeholder="Enter your password"
            />
          </div>
          <div class="form-group d-flex justify-content-between">
            <div *ngIf="false" class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" checked="" id="checkbox-remember" />
              <label class="custom-control-label" for="checkbox-remember">Запомнить?</label>
            </div>
            <a>Восстановить пароль</a>
          </div>
          <!-- Submit -->
          <button
            (mousemove)="allService.effectMouseMove($event)"
            disabled
            class="effectMouse effect-white btn btn-lg btn-block btn-primary d-flex align-items-center"
            type="submit"
          >
            Войти
            <i-feather [style.margin-top.px]="-5" name="log-in" class="ml-auto icon-md align-middle"></i-feather>
          </button>
        </form>
        <!-- Text
                <p class="text-center">
                  text
                </p>-->
      </div>
    </div>
  </div>
</div>
